import React, { Fragment, useEffect, useState, useMemo, useRef } from 'react';
// Estilos
import selectStyles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { makeStyles } from '@material-ui/core/styles';
// Permisos
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
// Grid
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
// Forms
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@material-ui/lab';
// Boton
import PaymentIcon from '@material-ui/icons/Payment';
import Button from 'components/CustomButtons/Button';
// Contexto
import { WithApp } from 'contexts/appContext';

// AppBar
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
// Tabs
import { TabPanel, indexTab } from 'hooks/TabPanel';
import TabTransfer from './Tabs/TabTransfer';
import TabCheck from './Tabs/TabCheck';
import TabCash from './Tabs/TabCash';

// Otros
import { wsGetAll } from 'services/WService';
import moment from 'moment';
import SwipeableViews from 'react-swipeable-views';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

const useStyles = makeStyles({
  ...styles,
  ...selectStyles,
  grid: {
    fontWeight: 'bold',
    textAlign: 'end',
  },
  div: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'space-around',
    flexWrap: 'nowrap',
    alignItems: 'baseline',
  },
  totalPay: {
    marginRight: '10px',
    fontSize: '17px',
  },
  input: {
    fontWeight: 'bold',
  },
});

const tabsComponent = [
  { type: 'CH', label: 'Fondo en efectivo' },
  { type: 'TR', label: 'Transferencia bancaria' },
  { type: 'CK', label: 'Cheque' },
  { type: 'LT', label: 'Letras', disabled: true },
];

function PaymentFooter(props) {
  const { showNotify, totalAmount, setTotalAmount, payWithDocuments } = props;
  const { paymentMethod, setPaymentMethod, onImport } = props;
  const { paymentType, process } = props;
  const { payment, setPayment } = props;
  const { checks, setChecks } = props;
  const {processing, setProcessing} = props;
  const [formPositions, setFormPositions] = useState([]);
  // const [processing, setProcessing] = useState(false); <--- ahora se pasa como props
  const [tabIndex, setTabIndex] = useState(0);

  // Estados para los tabs
  const [banks, setBanks] = useState([]);
  const [accounts, setAccounts] = useState([]);
  async function listBanks() {
    let response = await wsGetAll('base/bank');
    if (response.success) {
      setBanks(response.data);
    }
  }
  async function listAccounts() {
    let response = await wsGetAll('pymt/transfer-accounts');
    if (response.success) {
      setAccounts(response.data);
    }
  }
  const formPosition = useMemo(() => {
    return formPositions.find((position) => position.CFWId === payment.CFWId) || {};
  }, [payment.CFWId]);

  useEffect(() => {
    let entity = 'pymt/received-payment/form-positions';
    if (paymentType === 'ACCOMPLISHED') {
      entity = 'pymt/accomplished-payment/form-positions';
    }
    wsGetAll(entity).then((res) => setFormPositions(res.data));
  }, [paymentType]);

  useEffect(() => {
    listBanks();
    listAccounts();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setProcessing(true);
    await process();
    setProcessing(false);
  }

  return (
    <Fragment>
      <form id="formProcess" onSubmit={handleSubmit}>
        <GridContainer>

          <GridItem  xs={3} lg={1}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Moneda</InputLabel>
              <Select
                inputProps={{
                  name: 'DocCurr',
                }}
                defaultValue={"S/"}
                required
                onChange={(e) => {
                  let DocCurr = e.target.value;
                  setPayment((payment) => ({ ...payment, DocCurr }));
                }}
              >
                <MenuItem value="S/">Soles</MenuItem>
                <MenuItem value="US$">Dolares</MenuItem>
              </Select>
            </FormControl>
          </GridItem>
          {/* Total a pagar */}
          <GridItem xs={3} lg={1}>
            <TextField
              fullWidth
              required
              label="Total a pagar"
              type="number"
              value={totalAmount}
              margin="normal"
              inputProps={{
                min: 0,
                step: 0.01,
              }}
              onInput={(e) => {
                let value = e.target.value;
                // Permite solo hasta 2 decimales
                if (value && value.includes('.')) {
                  const [int, dec] = value.split('.');
                  if (dec.length > 2) {
                    value = int + '.' + dec.slice(0, 2);
                    e.target.value = value;
                  }
                }
                if (!payWithDocuments) {
                  setTotalAmount(parseFloat(value));
                }
              }}
            />
          </GridItem>

          {/* DocDate */}
          <AllowedGuard
            permission={
              paymentType === 'ACCOMPLISHED'
                ? ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_DOCDATE
                : ConstantPermissions.PYMT_RECEIVED_PAYMENTS_DOCDATE
            }
            component={
              <GridItem xs={3} lg={1}>
                <TextField
                  type="date"
                  label="Fec. contable"
                  fullWidth
                  value={payment.DocDate}
                  margin="normal"
                  disabled={true}
                />
              </GridItem>
            }
          >
            <GridItem xs={3} lg={1}>
              <TextField
                type="date"
                label="Fec. contable"
                fullWidth
                value={payment.DocDate}
                margin="normal"
                required
                // disabled={true}
                // inputProps={{
                //   min: moment().subtract(2, 'days').format('YYYY-MM-DD'),
                //   max: moment().format('YYYY-MM-DD')
                // }}
                onChange={(e) => {
                  let DocDate = e.target.value;
                  setPayment((payment) => ({ ...payment, DocDate }));
                }}
              />
            </GridItem>
          </AllowedGuard>

          {/* CFWId Posición formulario */}
          {paymentType === 'ACCOMPLISHED' && (
            <GridItem xs={6} lg={3}>
              <Autocomplete
                fullWidth
                value={formPosition}
                options={formPositions}
                renderInput={(params) => (
                  <TextField {...params} label="Posición formulario" margin="normal" required />
                )}
                getOptionLabel={(option) => {
                  return option?.CFWName || '';
                }}
                onChange={(e, value) => {
                  let CFWId = undefined;
                  if (value !== null) {
                    CFWId = value.CFWId;
                  }
                  setPayment((payment) => ({ ...payment, CFWId }));
                }}
              />
            </GridItem>
          )}

          {/* Comments */}
          <GridItem xs={6} lg={3}>
            <TextField
              multiline
              label="Comentario"
              fullWidth
              value={payment.Comments || ''}
              margin="normal"
              required
              onChange={(e) => {
                let Comments = e.target.value;
                setPayment((payment) => ({ ...payment, Comments }));
              }}
            />
          </GridItem>

          {/* <GridItem xs={6} lg={2}>
            <Button
              fullWidth
              type="submit"
              form="formProcess"
              color={props.themeContext.buttonColorSuccess}
              disabled={processing || paymentMethod === null}
            >
              <PaymentIcon /> Procesar
            </Button>
          </GridItem> */}
        </GridContainer>
      </form>

      {/* Tabs tipos de pago */}
      <GridContainer>
        <GridItem xs={12}>
          <AppBar position="static" color="default">
            <Tabs
              value={tabIndex}
              onChange={(e, index) => {
                setTabIndex(index);
              }}
              variant="scrollable"
              scrollButtons="auto"
              textColor="secondary"
              aria-label="Tabs"
              indicatorColor="secondary"
            >
              {tabsComponent.map((item, i) => {
                return (
                  <Tab
                    key={i}
                    label={item.label}
                    {...indexTab(i)}
                    disabled={
                      (paymentMethod !== null && paymentMethod !== item.type) ||
                      item.disabled === true
                    }
                  />
                );
              })}
            </Tabs>
          </AppBar>
          <SwipeableViews index={tabIndex}>
            {/* Efectivo */}
            <TabPanel value={tabIndex} index={0}>
              <TabCash
                payWithDocuments={payWithDocuments}
                totalAmount={totalAmount}
                payment={payment}
                setPayment={setPayment}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
              />
            </TabPanel>
            {/* Transferencia */}
            <TabPanel value={tabIndex} index={1}>
              <TabTransfer
                payWithDocuments={payWithDocuments}
                totalAmount={totalAmount}
                payment={payment}
                setPayment={setPayment}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
              />
            </TabPanel>
            {/* Cheque */}
            <TabPanel value={tabIndex} index={2}>
              <TabCheck
                payWithDocuments={payWithDocuments}
                totalAmount={totalAmount}
                payment={payment}
                setPayment={setPayment}
                checks={checks}
                setChecks={setChecks}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
              />
            </TabPanel>
          </SwipeableViews>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
}

export default WithApp(PaymentFooter);
